import { Component, OnInit } from '@angular/core';
import { QueryStringService } from '@xref/ngx';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'xqnr-oauth-connect',
  templateUrl: './oauth-connect.component.pug',
  styleUrls: ['./oauth-connect.component.scss'],
  standalone: false
})
export class OauthConnectComponent implements OnInit {

  constructor(
    private qs: QueryStringService,
    private auth: AuthService,
    private router: Router
  ) { }

  ngOnInit() {
    this.login();
  }

  loginSuccess = () => {
    const redirectUrl = this.auth.getAuthRetUrl();
    this.router.navigateByUrl(redirectUrl);
  };

  loginError(err: any) {
    console.error(err);
  }

  login() {
    const accessToken = this.qs.getHash('access_token');
    const region = this.qs.getHash('region');

    this.auth.loginWithAccessToken(accessToken, region)
      .subscribe(this.loginSuccess, this.loginError);
  }
}
